import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import { useAuthStore } from '@stores/auth';
import { useConfigStore } from '@stores/config';

// "Přidat do sbírky" state of a CataloguePost: whether its category is enabled for the collection,
// how many collection items already reference it, and navigation to the collection / add form.
// `variant` is a getter returning the CataloguePost.
export default function (variant) {
  const { $eventBus } = useNuxtApp();
  const auth = useAuthStore();
  const configs = useConfigStore();

  // Categories enabled for the collection, loaded once per session for all buttons.
  const stockCategories = useState('stock.categories', () => null);
  const count = ref(0);
  // CataloguePost id the `count` was loaded for; the button waits for it, so its label does not switch.
  const countPostId = ref(null);

  const enabled = computed(() => configs.stockFeature && auth.isLoggedIn && !!variant()?.id);
  const inStockCategory = computed(() => enabled.value && _.some(stockCategories.value || [], { id: variant()?.category?.id }));
  const available = computed(() => inStockCategory.value && countPostId.value === variant()?.id);

  const load = async () => {
    if (!enabled.value) return;
    if (stockCategories.value === null) {
      stockCategories.value = await stockCategoriesLoad() || [];
    }
    if (inStockCategory.value) {
      const id = variant().id;
      const result = await stockItemsLoad({ cataloguePost: id, limit: 1 });
      if (id !== variant()?.id) return;
      count.value = result?.pagination?.itemCount || 0;
      countPostId.value = id;
    }
  };

  const navigate = async () => {
    $eventBus.emit('modal:close');
    $eventBus.emit('sidebar:close');
    await navigatorTo(count.value
      ? { path: translatePath(ROUTES.CODE.STOCK), query: { cataloguePost: variant().id } }
      : { path: translatePath(ROUTES.CODE.STOCK_ADD), query: { post: variant().id } });
  };

  // `enabled` also covers the config / login state arriving after mount (SSR-rendered header).
  watch(() => [variant()?.id, variant()?.category?.id, enabled.value], load);
  onMounted(load);

  return { count, available, navigate };
}
